import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";

const AdminAuditLog = () => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { adminApi.get("/audit-log").then((res) => setEntries(res.data)).finally(() => setLoading(false)); }, []);

  return (
    <AdminPageShell title="Audit Log" description="A record of administrative actions taken across the Command Centre." testId="admin-audit-log-page">
      {loading ? <p className="text-small">Loading…</p> : (
        <div className="space-y-2">
          {entries.map((e) => (
            <div key={e.id} className="neu-surface p-4 flex items-center justify-between gap-4 flex-wrap" data-testid={`admin-audit-row-${e.id}`}>
              <p className="text-small"><span style={{ color: "var(--gg-logo-gold)" }}>{e.actor_email}</span> {e.action} {e.module} {e.target_id ? `(${e.target_id.slice(0, 8)})` : ""}</p>
              <p className="text-small">{new Date(e.created_at).toLocaleString()}</p>
            </div>
          ))}
          {entries.length === 0 && <p className="text-small">No activity recorded yet.</p>}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminAuditLog;
